import React, { useEffect } from 'react';
import { RegisterOptions, useFormContext, useWatch } from 'react-hook-form';
import classNames from 'classnames';

interface Props {
  readonly onChange: (checked: boolean) => void;
  readonly checked: boolean;
  readonly name: string;
  readonly disabled?: boolean;
  readonly autoComplete?: string;
  readonly containerClassNames?: string;
  readonly inputClassNames?: string;
  readonly validation?: RegisterOptions;
}

const CheckboxElement = ({
  onChange,
  checked,
  disabled,
  name,
  containerClassNames,
  inputClassNames,
  validation,
}: Props) => {
  const { register, control } = useFormContext();

  const fieldValue = useWatch({
    control,
    name: name,
  });

  useEffect(() => {
    onChange(fieldValue);
  }, [fieldValue, onChange]);

  return (
    <div className={containerClassNames || 'flex h-5 items-center'}>
      <input
        type="checkbox"
        id={name}
        name={name}
        className={classNames(
          inputClassNames,
          'size-6 rounded border-2 border-neutral-700 text-transparent',
          disabled ? 'cursor-default' : 'cursor-pointer',
        )}
        onChange={(e: React.FormEvent) => onChange((e.target as HTMLInputElement).checked)}
        defaultChecked={checked}
        disabled={disabled}
        {...register(name, validation)}
      />
    </div>
  );
};

export default CheckboxElement;
